
    import { makeI18n } from '@/services/i18n';
    const baseTranslation = undefined
    
    
    if(module.hot) {
      const bucket = require("/app/build/i18n/browser-bucket.js");
      bucket.add('src/modules/registration/components/DemoForm.vue', {"consent":{"ru_RU":"Отправляя форму, я&nbsp;даю согласие на&nbsp;обработку перс. данных в&nbsp;соответствии с&nbsp;","en_US":"By submitting this form, I consent to the processing of my personal data in accordance with Huntflow's"},"consent.link":{"ru_RU":"Политикой&nbspконфиденциальности","en_US":"privacy&nbsppolicy"},"logout":{"ru_RU":"Выйти","en_US":"Log out"},"need-logout":{"ru_RU":"Для получения нового демо-доступа необходимо выйти из вашего текущего Хантфлоу.","en_US":"To get a new trial, you need to log out of your current Huntflow account."},"need-logout.goto":{"ru_RU":"Перейти в ваш Хантфлоу","en_US":"Go to your Huntflow"},"submit":{"ru_RU":"Получить демо-доступ","en_US":"Get a demo"},"title":{"ru_RU":"Демо-доступ к Хантфлоу","en_US":"Huntflow Demo"},"timezone":{"ru_RU":"Часовой пояс","en_US":"Timezone"},"language":{"ru_RU":"Язык интерфейса","en_US":"Interface language"},"language.ru":{"ru_RU":"Русский язык интерфейса","en_US":"Russian"},"language.en":{"ru_RU":"Английский язык интерфейса","en_US":"English"},"name":{"ru_RU":"Название вашей организации","en_US":"Company name"},"username":{"ru_RU":"Ваше имя","en_US":"Full name"},"position":{"ru_RU":"Ваша должность","en_US":"Job title"},"phone":{"ru_RU":"Ваш телефон для связи","en_US":"Contact phone number"},"email":{"ru_RU":"Ваша эл. почта","en_US":"Email"},"need-login":{"ru_RU":"Эл. почта уже зарегистрирована.","en_US":"Sorry, this email is already registered."},"need-login.login":{"ru_RU":"Войти в Хантфлоу","en_US":"Log in"}}) 
    }
   
    
    export default function (Component) {
      function beforeCreateI18n() {
        this.$i18n = this.$options._i18n;
      }

      function addHook(current) {
        if (Array.isArray(current)) {
          return [beforeCreateI18n].concat(current);
        } 
        if (current) {
          return [beforeCreateI18n, current];
        }
        return [beforeCreateI18n];
      }
    
      Component._i18n = makeI18n("src/modules/registration/components/DemoForm.vue", baseTranslation);
      Component.beforeCreate = addHook(Component.beforeCreate);
      delete Component._Ctor;
    }
  